<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Distributor",
};
</script>

<style lang="scss" scoped></style>
